<template>
  <div class="map-grid">
    <div
      v-ripple
      class="sidebar-left-1 sidebar"
      @click="
        openFolder(sideBarClientObject, elements.sidebarLeft1);
        backToMainContent(false);
      "
      :class="{ highlight: selectedElement === elements.sidebarLeft1 }"
    >
      <p>KUNDE/ BESTELLER</p>
    </div>
    <div
      v-ripple
      class="sidebar-left-2 sidebar"
      @click="
        openFolder(sideBarLeftObject, elements.sidebarLeft2);
        backToMainContent(false);
      "
      :class="{ highlight: selectedElement === elements.sidebarLeft2 }"
    >
      <p>Ausschreibung/ Tarifverbund</p>
    </div>

    <div v-show="hasMainContent" class="input-box foreground" @click="openFolder(inputProcessObject, elements.inputBox)">
      <div v-ripple class="input-box-content box-content" :class="{ highlight: selectedElement === elements.inputBox }">
        <p>INPUT</p>
        <p v-if="xl">Kundenbedürfnis</p>
        <div v-else>
          <p>Kunden-</p>
          <p>bedürfnis</p>
        </div>
      </div>
    </div>
    <div
      v-show="hasMainContent"
      v-ripple
      class="title-box foreground flex-center"
      @click="openFolder(titleProcessObject, elements.titleBox)"
      :class="[{ highlight: selectedElement === elements.titleBox }, fontSize]"
    >
      <p>KERNPROZESSE</p>
    </div>
    <div v-show="!hasMainContent" class="title-box foreground flex-center">
      <v-btn outlined color="white" rounded @click="backToMainContent"><v-icon>mdi-arrow-left-top</v-icon></v-btn>
    </div>
    <div v-show="hasMainContent" class="output-box foreground" @click="openFolder(outputProcessObject, elements.outputBox)">
      <div v-ripple class="output-box-content box-content" :class="{ highlight: selectedElement === elements.outputBox }">
        <p>OUTPUT</p>
        <p v-if="xl">Kundenzufriedenheit</p>
        <div v-else>
          <p>Kunden-</p>
          <p>zufriedenheit</p>
        </div>
      </div>
    </div>

    <div class="content-container"><!-- Blue Background --></div>

    <div class="content-left foreground" :class="fontSize">
      <div v-ripple v-for="content in filteredContentLeft" :key="'contentLeft-' + content.name" @click="openMap(content)" class="content-arrow"  :class="{highlight:(folder && folder.name===content.name)}">
        <p>{{ content.name }}</p>
      </div>
    </div>
    <div class="content-right foreground" :class="[{ 'content-no-filter': filteredContentRight.length === 1 }, fontSize]">
      <div
        v-ripple
        v-for="content in filteredContentRight"
        :key="'contentRight-' + content.name"
        @click="openFolder(content, content.name)"
        class="content-arrow"
        :class="{ 'content-no-clip': filteredContentRight.length === 1, highlight: selectedElement === content.name }"
      >
        <p>{{ content.name }}</p>
      </div>
    </div>

    <div
      v-ripple
      class="sidebar-right sidebar"
      @click="
        openFolder(sideBarClientObject, elements.sidebarRight);
        backToMainContent(false);
      "
      :class="{ highlight: selectedElement === elements.sidebarRight }"
    >
      <p>KUNDE/ BESTELLER</p>
    </div>

    <div
      v-show="hasMainContent"
      v-for="(bottom, index) in filteredBottomBox"
      :key="'bottom-' + bottom.name"
      @click="openFolder(bottom, bottom.name)"
      :class="index === 0 ? 'bottom-box-left' : 'bottom-box-right'"
      class="foreground"
    >
      <div
        v-ripple
        :class="[index === 0 ? 'bottom-box-left-content' : 'bottom-box-right-content', botFontSize, { highlight: selectedElement === bottom.name }]"
        class="box-content"
      >
        <p>{{ bottom.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import { mapState } from 'vuex';
export default {
  name: 'MapContainer',
  mixins: [common],
  data() {
    return {
      selectedElement: null,
      elements: {
        sidebarLeft1: 'sidebar-left-1',
        sidebarLeft2: 'sidebar-left-2',
        inputBox: 'input-box',
        titleBox: 'title-box',
        outputBox: 'output-box',
        sidebarRight: 'sidebar-right',
      },
      contentLeftObject_: {
        Verkauf: ['öV: abgeltungsberechtigt Bund / Kantone', 'Extrafahrten: nicht abgeltungsberechtigt', 'Fahrgäste'],
        Kundenservice: [],
        'Dienstleistung Personentransport': ['Fahrplan', 'Umläufe', 'Fahrdienste', 'Personaldisposition', 'Leitstelle'],
        'Dienstleistung für Dritte': ['Mieter', 'Werbetechnik', 'Akademie', 'Werkstatt'],
      },
      contentLeftObject: [
        { name: 'Verkauf', children: ['öV: abgeltungsberechtigt Bund / Kantone', 'Extrafahrten: nicht abgeltungsberechtigt', 'Fahrgäste'] },
        { name: 'Kundenservice', children: [] },
        { name: 'Dienstleistung Personentransport', children: ['Fahrplan', 'Umläufe', 'Fahrdienste', 'Personaldisposition', 'Leitstelle'] },
        { name: 'Dienstleistung für Dritte', children: ['Mieter', 'Werbetechnik', 'Akademie', 'Werkstatt'] },
      ],

      filteredContentLeft: [],
      contentRightArray: ['Fahrleistung', 'Produktleistung'],
      filteredContentRight: [],
      bottomBoxArray: ['Kontinuierlicher Verbesserungsprozess (KVP)', 'Feedback'],
      filteredBottomBox: [],
      //headerArray: ['Input Kundenbedürfnis', 'Kernprozesse', 'Output Kundenzufriedenheit'],
      inputProcess: 'Input Kundenbedürfnis',
      inputProcessObject: {},
      titleProcess: 'Kernprozesse',
      titleProcessObject: {},
      outputProcess: 'Output Kundenzufriedenheit',
      outputProcessObject: {},
      sideBarClientProcess: 'Kunde/ Besteller',
      sideBarClientObject: {},
      sideBarLeftProcess: 'Ausschreibung/ Tarifverbund',
      sideBarLeftObject: {},
    };
  },
  computed: {
    ...mapState('documents', ['dataLoaded', 'documents', 'folders', 'foldersById']),
    fontSize() {
      if (this.xs) {
        return 'small-font-size';
      } else if (this.xl) {
        return 'xxlarge-font-size';
      } else {
        return '';
      }
    },
    botFontSize() {
      if (this.mdAndDown) {
        return 'small-font-size';
      } else if (this.xl) {
        return 'xlarge-font-size';
      } else {
        return '';
      }
    },
    /**
     * Check if the main content exists.
     *
     * @return {boolean} the result of the check
     */
    hasMainContent() {
      if (this.filteredContentLeft.length === 0) {
        return false;
      }
      const contentLeftArray = this.contentLeftObject.map((item) => item.name);
      return this.filteredContentLeft.every((content) => {
        return contentLeftArray.includes(content.name);
      });
    },
    folderId(){
      return this.$route.params.folderId
    },
    folder(){
      return this.foldersById[this.folderId]
    }
  },
  methods: {
    // TODO Ricardo: this needs some serious refactoring
    computeFilteredFolderProcesses() {
      if (this.foldersById && Object.keys(this.foldersById).length > 0) {
        this.filteredFolderProcesses = [];
        Object.keys(this.foldersById).forEach((key) => {
          const item = this.foldersById[key];
          const itemName = item.name.trim();
          if (this.contentLeftObject.find((clo) => clo.name === itemName)) {
            this.filteredContentLeft.push(item);
          } else if (this.contentRightArray.includes(itemName)) {
            this.filteredContentRight.push(item);
          } else if (this.bottomBoxArray.includes(itemName)) {
            this.filteredBottomBox.push(item);
          } else if (itemName === this.inputProcess) {
            this.inputProcessObject = item;
          } else if (itemName === this.titleProcess) {
            this.titleProcessObject = item;
          } else if (itemName === this.outputProcess) {
            this.outputProcessObject = item;
          } else if (itemName === this.sideBarClientProcess) {
            this.sideBarClientObject = item;
          } else if (itemName === this.sideBarLeftProcess) {
            this.sideBarLeftObject = item;
          }
        });
      }
    },
    resetFilteredProcesses() {
      this.filteredBottomBox = [];
      this.filteredContentRight = [];
      this.filteredContentLeft = [];
    },
    /**
     * Open a folder and navigate to the document folder route.
     *
     * @param {Object} process - The process object containing instance and folderId
     * @param elementId
     * @return {void}
     */
    openFolder(process, elementId = null) {
      this.selectedElement = elementId;
      this.mx_isLeftDrawerOpen = true;
      this.$router.push({ name: 'documentFolder', params: { instance: process.instance, folderId: process.id } });
    },
    /**
     * Opens the map based on the provided process.
     *
     * @param {Object} process - The process object containing name, instance, and id
     * @return {void}
     */
    openMap(process) {
      if (!process) return;
      let processName = process.name;


      const contentLeftProcess = this.contentLeftObject.find((clo) => {
        if (clo.name === processName) {
          return true;
        }
        if (clo.children) {
          return clo.children.includes(processName);
        }
      });
      if (!contentLeftProcess) return;

      this.$router.push({ name: 'documentFolder', params: { instance: process.instance, folderId: process.id } });
      if (contentLeftProcess && contentLeftProcess.name !== processName) {
        //if (!Object.prototype.hasOwnProperty.call(this.contentLeftObject, processName)) {
        this.mx_isLeftDrawerOpen = true; // opens drawer when the last process is clicked
        // return;
        let folder = this.foldersById[process.id];
        let parentFolder = this.foldersById[folder.parentId];
        if (parentFolder) {
          process = parentFolder;
          processName = process.name;
        }
      }

      this.filteredContentLeft = [];
      this.filteredContentRight = [];

      this.filteredContentRight.push(process);

      Object.keys(this.foldersById).forEach((key) => {
        const folder = this.foldersById[key];
        const folderName = folder.name.trim();
        const subProcess = this.contentLeftObject.find((clo) => clo.name === processName);

        if (subProcess && subProcess.children.includes(folderName)) {
          this.filteredContentLeft.push(folder);
        }
      });
    },
    backToMainContent(changeToMainFolders = true) {
      if (!this.xs) {
        this.mx_isLeftDrawerOpen = false;
      }
      if (changeToMainFolders) {
        this.$router.push({ name: 'documentsRoot', params: { instance: this.$route.params.instance } });
      }
      this.resetFilteredProcesses();
      this.computeFilteredFolderProcesses();
    },
  },
  watch: {
    foldersById: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.resetFilteredProcesses();
          this.computeFilteredFolderProcesses();
        }
      },
    },
    '$route.params.folderId': {
      immediate: true,
      deep: true,
      handler(to, from) {
        if (to !== from) {
          if (to) {
            this.openMap(this.foldersById[to]);
          } else {
            this.resetFilteredProcesses();
            this.computeFilteredFolderProcesses();
          }
        }
      },
    },
  },
};
</script>

<style scoped>
/* GRID */
.map-grid {
  display: grid;
  grid-template-columns: repeat(2, 0.2fr) repeat(5, 1fr) 0.2fr;
  grid-template-rows: 0.15fr 1fr 0.15fr;
  grid-column-gap: 0;
  grid-row-gap: 0;
  height: auto;
}

.content-container {
  grid-area: 1 / 3 / 4 / 8;
  background-color: #1682c8;
  clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 0% 0%);
}
.sidebar-left-1 {
  grid-area: 1 / 1 / 5 / 2;
  border-right: 1px solid #ffffff;
}
.sidebar-left-2 {
  grid-area: 1 / 2 / 5 / 3;
  border-right: 1px solid #ffffff;
}
.input-box {
  grid-area: 1 / 2 / 2 / 4;
  margin: 7px 0;
  filter: drop-shadow(3px 3px 5px #333333);
}
.sidebar-right {
  grid-area: 1 / 8 / 5 / 9;
}
.output-box {
  grid-area: 1 / 7 / 2 / 9;
  margin: 7px 0;
  filter: drop-shadow(3px 3px 5px #333333);
}
.title-box {
  grid-area: 1 / 4 / 2 / 7;
}
.content-right {
  grid-area: 2 / 6 / 3 / 8;
  filter: drop-shadow(3px 3px 5px #333333);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.5vh;
  padding: 1em 0;
}

.content-right > .content-arrow:first-child {
  height: 74%;
}

.content-right .content-arrow:last-child {
  flex-grow: 1;
}

.content-left {
  grid-area: 2 / 3 / 3 / 6;
  filter: drop-shadow(3px 3px 5px #333333);
  display: flex;
  gap: 1.5vh;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 1em 0;
}
.bottom-box-right {
  grid-area: 3 / 6 / 4 / 9;
  margin: 7px 0;
}
.bottom-box-left {
  grid-area: 3 / 3 / 4 / 6;
  filter: drop-shadow(3px 3px 5px #333333);
  margin: 7px 0;
}
/* END GRID */

.foreground {
  position: relative;
  z-index: 2;
}

.title-box p {
  font-weight: bolder;
  margin: 0;
  font-size: larger;
  color: #ffffff;
}

.content-left > .content-arrow {
  height: 100%;
}

.content-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0 100%, 0 0);
  background-color: #1682c8;
  width: 80%;
  padding: 0 7px;
}

.content-no-clip {
  clip-path: none;
}

.content-no-filter {
  filter: none;
}

.content-arrow p {
  margin: 0;
  color: #ffffff;
  font-weight: bold;
}

.box-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.box-content > div > p {
  font-size: small;
}

.box-content p {
  margin: 0;
  color: #ffffff;
  font-weight: bold;
}

.input-box-content {
  height: 100%;
  clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 0% 0%);
  background: rgb(51, 51, 51);
  background: linear-gradient(90deg, rgba(51, 51, 51, 1) 0%, rgba(22, 130, 200, 1) 70%);
}

.output-box-content {
  height: 100%;
  clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 0% 0%);
  background: rgb(51, 51, 51);
  background: linear-gradient(90deg, rgba(22, 130, 200, 1) 30%, rgba(51, 51, 51, 1) 100%);
}

.bottom-box-right-content {
  height: 100%;
  background-color: rgba(51, 51, 51, 0.5);
  clip-path: polygon(100% 0, 90% 50%, 100% 100%, 10% 100%, 0 50%, 10% 0);
}

.bottom-box-left-content {
  height: 100%;
  background-color: #1682c8;
  clip-path: polygon(100% 0, 90% 50%, 100% 100%, 10% 100%, 0 50%, 10% 0);
  padding: 0 0.4em;
}

.xsmall-font-size p {
  font-size: x-small;
}

.small-font-size p {
  font-size: small;
}

.xlarge-font-size p {
  font-size: x-large;
}

.xxlarge-font-size p {
  font-size: xx-large;
}

.sidebar {
  background-color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sidebar p {
  margin: 0;
  color: #ffffff;
  font-weight: bold;
  transform: rotate(180deg);
  writing-mode: vertical-lr;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.highlight {
  /*filter: brightness(50%);*/
  background: none;
  background-color: #005289;
}
</style>
